import { useEffect } from 'react';

import { FatalAttraction as FA } from '@vpr/tracking';

import styles from './EmbedPlaylistApp.module.scss';
import PlaylistContainer from './PlaylistContainer';
import { UpcomingEvents } from '../../live-player-cards';
import DismissButton from '../components/DismissButton';
import PlaylistHeader from '../components/PlaylistHeader';
import PlaylistPlaybar from '../components/PlaylistPlaybar';
import PlaylistTracklist from '../components/PlaylistTracklist';
import PlaylistWrapper from '../components/PlaylistWrapper';
import UpNext from '../components/UpNext';
import NextLiveClip from '../containers/NextLiveClip';

const EmbedPlaylistApp = (props) => {
  useEffect(() => {
    const playerContainer = document.getElementsByClassName('js-player')[0];
    const nextDiv = document.getElementById('__next');
    if (playerContainer.contains(nextDiv)) {
      return;
    }
    playerContainer.prepend(nextDiv);
  }, []);

  useEffect(() => {
    /**
     * Why are we doing this?
     * For some unknown reason, the URL of the iframe is being changed to /video/<video_id> by the player code when we switch to the next video in the playlist (showcase playlist as well as event playlist).
     * I am storing the original url here, so it can re reused in later stages
     */
    window.originalUrl = window.location.href;
  }, []);

  return (
    <PlaylistContainer
      playlistData={props.playlistData}
      clips={props.clips}
      isRLE={props.isRLE}
      player={props.player}
      playerEl={props.playerEl}
      hidePlaylistUI={props.hidePlaylistUI}
      render={({
        addNewLiveClip,
        playlistData,
        clips,
        currentLiveViewers,
        headerRef,
        isLive,
        isLoading,
        isMobile,
        isPlaying,
        isShowing,
        isTiny,
        nextClip,
        nextLiveClip,
        onMouseEnter,
        onMouseLeave,
        previousClip,
        selectedClipId,
        showUpNext,
        switchClip,
        toggleTracklist,
        tracklistExpanded,
        tracklistRef,
        upNextClip,
        hidePlaylistUI,
      }) => (
        <div>
          <PlaylistWrapper
            isMobile={isMobile}
            isShowing={isShowing && !hidePlaylistUI}
            isTiny={isTiny}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            tracklistExpanded={tracklistExpanded}
          >
            <PlaylistHeader
              clips={clips}
              headerRef={headerRef}
              isMobile={isMobile}
              privacy={playlistData.privacy}
              title={playlistData.title}
              tracklistExpanded={tracklistExpanded}
              user={playlistData.user}
            />
            <div className={styles.playlistContainer}>
              {isMobile && tracklistExpanded ? (
                <DismissButton
                  onClick={() => {
                    toggleTracklist();
                    FA.trackClick({
                      container: 'embedded_playlist',
                      component: 'collapse_options',
                    });
                  }}
                />
              ) : (
                <PlaylistPlaybar
                  clips={clips}
                  isLoading={isLoading}
                  isMobile={isMobile}
                  nextClip={nextClip}
                  playlistData={playlistData}
                  previousClip={previousClip}
                  selectedClipId={selectedClipId}
                  toggleTracklist={toggleTracklist}
                  tracklistExpanded={tracklistExpanded}
                />
              )}
              <PlaylistTracklist
                clips={clips}
                currentLiveViewers={currentLiveViewers}
                isExpanded={tracklistExpanded}
                isMobile={isMobile}
                isPlaying={isPlaying}
                selectedClipId={selectedClipId}
                switchClip={switchClip}
                tracklistRef={tracklistRef}
              />

              {playlistData.showPlaylist && showUpNext && upNextClip && (
                <UpNext
                  clip={upNextClip}
                  clips={clips}
                  onMouseLeave={onMouseLeave}
                  switchClip={switchClip}
                  loop={playlistData.loop}
                />
              )}
            </div>
          </PlaylistWrapper>

          {nextLiveClip && <NextLiveClip addNewLiveClip={addNewLiveClip} clip={nextLiveClip} />}

          {props.liveEvent && props.liveEvent.schedule && playlistData.showSchedule && (
            <UpcomingEvents
              isShowing={
                !tracklistExpanded &&
                !isPlaying &&
                !isMobile &&
                !isLive &&
                !(nextLiveClip && nextLiveClip.isLive)
              }
              schedule={props.liveEvent.schedule}
            />
          )}
        </div>
      )}
    />
  );
};

export default EmbedPlaylistApp;
